import React from 'react';
import 'twin.macro';
import useSchoolyears from 'queries/schoolyears/useSchoolyears';
import SpinnerComponent from '@teetsh/app/src/components/Spinner/ScreenSpinner';
import _orderBy from 'utils/arrays/orderBy';
import { SequenceCustomFields } from './SequenceCustomFields';
import { EventCustomFields } from './EventCustomFields';
import { useTranslation } from 'react-i18next';

export function NewCustomFieldsSettings() {
  const { data: schoolyears = [], isLoading } = useSchoolyears(false, true);
  const { t } = useTranslation(['userSettings']);

  if (isLoading) {
    return <SpinnerComponent />;
  }

  return (
    <div tw="flex flex-col gap-y-8">
      <div>
        <h3>{t('userSettings:customFields.customFieldForSequences')}</h3>
        <SequenceCustomFields />
      </div>
      <div>
        <h3>{t('userSettings:customFields.customFieldForSchool')}</h3>
        {_orderBy(schoolyears, ['year'], ['desc']).map(sy =>
          _orderBy(sy.schools, ['name'], ['asc']).map(sc => (
            <EventCustomFields key={sc.id} schoolyear={sy} school={sc} />
          )),
        )}
      </div>
    </div>
  );
}
